import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import * as maintenanceActions from '@app/maintenance/store/maintenance.actions';
import {
    AddRecurrenceSuccessAction,
    DeleteRecurrenceSuccessAction,
    UpdateRecurrenceSuccessAction,
    UpdateActivitiesSuccessAction,
    AddActivitySuccessAction,
    UpdateTaskSuccessAction,
    DeleteTaskSuccessAction,
    DeleteActivitySuccessAction,
    UpdateActivitySuccessAction,
    AddTaskSuccessAction,
    AddPlanSuccessAction,
    DeleteMaintenancePlanSuccessAction,
    UpdatePlanSuccessAction, DeleteMaintenancePlanFailedAction
} from '@app/maintenance/store/maintenance.actions';
import { map } from 'rxjs/operators';
import { ToastsManager } from "@app/shared/util/toastr.service";
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class MaintenanceNotificationsEffects {

    // Add recurrence success
    addRecurrenceSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.ADD_RECURRENCE_SUCCESS),
        map((data: AddRecurrenceSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.addRecurrenceSuccess',
                {recurrenceName: data.payload.name})
            , null, {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Update recurrence success
    updateRecurrenceSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.UPDATE_RECURRENCE_SUCCESS),
        map((data: UpdateRecurrenceSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.updateRecurrenceSuccess',
                {recurrenceName: data.payload.name})
            , null,
            {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Delete recurrence success
    deleteRecurrenceSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.DELETE_RECURRENCE_SUCCESS),
        map((data: DeleteRecurrenceSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.deleteRecurrenceSuccess',
                {recurrenceName: data.payload.name})
            , null,
            {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Add activity success
    addActivitySuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.ADD_ACTIVITY_SUCCESS),
        map((data: AddActivitySuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.addActivitySuccess',
                {activityName: data.payload.name})
            , null, {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Update activities success
    UpdateActivitiesSuccessAction$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.UPDATE_ACTIVITIES_SUCCESS),
        map((data: UpdateActivitiesSuccessAction) => this.toastr.success(
            this.translateService.instant(
                'admin.toolMaintenancePlans.notifications.updateActivitiesSuccess'
            ), null, {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Update activity success
    updateActivitySuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.UPDATE_ACTIVITY_SUCCESS),
        map((data: UpdateActivitySuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.updateActivitySuccess',
                {activityName: data.payload.name})
            , null,
            {toastLife: environment.toasts.duration}))
    ), {dispatch: false});


    // Delete activity success
    deleteActivitySuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.DELETE_ACTIVITY_SUCCESS),
        map((data: DeleteActivitySuccessAction) => {
            this.toastr.success(
                this.translateService.instant('admin.toolMaintenancePlans.notifications.deleteActivitySuccess',
                    {activityId: data.payload})
                , null,
                {toastLife: environment.toasts.duration})
        })
    ), {dispatch: false});

    // Add task success
    addTaskSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.ADD_TASK_SUCCESS),
        map((data: AddTaskSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.addTaskSuccess',
                {activityTaskName: data.payload.name})
            , null, {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Update task success
    updateTaskSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.UPDATE_TASK_SUCCESS),
        map((data: UpdateTaskSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.updateTaskSuccess',
                {taskName: data.payload.name})
            , null,
            {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Delete task success
    deleteTaskSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.DELETE_TASK_SUCCESS),
        map((data: DeleteTaskSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.deleteTaskSuccess',
                {taskId: data.payload})
            , null,
            {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Add plan success
    addPlanSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.ADD_PLAN_SUCCESS),
        map((data: AddPlanSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.addPlanSuccess',
                {planName: data.payload.name})
            , null, {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    // Delete plan success
    deletePlanSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.DELETE_MAINTENANCE_PLAN_SUCCESS),
        map((data: DeleteMaintenancePlanSuccessAction) => {
            this.router.navigate(['/tool-maintenance-plans/plans']);
            this.toastr.success(this.translateService.instant('admin.toolMaintenancePlans.notifications.deleteMaintenancePlanSuccess',
                    {maintenancePlanId: data.payload})
                , null,
                {toastLife: environment.toasts.duration});
        })
    ), {dispatch: false});

    // Delete plan success
    deletePlanError$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.DELETE_MAINTENANCE_PLAN_FAILED),
        map((data: DeleteMaintenancePlanFailedAction) => {
            let errorMessage = this.translateService.instant('admin.toolMaintenancePlans.notifications.deleteMaintenancePlanError');
            if (data.payload && data.payload.error && data.payload.error.message) {
                errorMessage = this.translateService.instant(data.payload.error.message);
            }
            this.toastr.error(errorMessage);
        })
    ), {dispatch: false});

    // Update plan success
    updatePlanSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(maintenanceActions.UPDATE_PLAN_SUCCESS),
        map((data: UpdatePlanSuccessAction) => this.toastr.success(
            this.translateService.instant('admin.toolMaintenancePlans.notifications.updatePlanSuccess',
                {planName: data.payload.name})
            , null,
            {toastLife: environment.toasts.duration}))
    ), {dispatch: false});

    constructor(
        private translateService: TranslateService,
        private toastr: ToastsManager,
        private actions$: Actions,
        private router: Router
    ) {
    }
}
